var isUpper = function (c) { return c >= 'A' && c <= 'Z'; };
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */
export default function hyphenateStyleName(string) {
    var output = '';
    for (var i = 0; i < string.length; i++) {
        var c = string[i];
        // Check for CSS variable prefix
        if (i === 1 && c === '-' && string[0] === '-') {
            return string;
        }
        if (isUpper(c)) {
            output += '-' + c.toLowerCase();
        }
        else {
            output += c;
        }
    }
    return output.startsWith('ms-') ? '-' + output : output;
}
//# sourceMappingURL=hyphenateStyleName.js.map